import Images from '@assets/images';
import { Accordion, Button, Typography } from '@components/base';
import { Avatar, DocumentRow } from '@components/common';
import { DOCUMENT_GENERATION_STATUS } from '@helpers/constants';
import { AppContext } from '@helpers/hooks/AppContext';
import { ITaskTabProps } from '@helpers/types/task-tabs';
import { getFormattedDate } from '@helpers/utils';
import moment from 'moment';
import { useContext, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Footer from '../components/footer';
import css from './index.module.scss';
import { Link } from 'react-router-dom';

interface IPICard {
  taskData: Array<Partial<ITaskTabProps>>;
}

const GeneratePICard = (props: IPICard) => {
  const navigate = useNavigate();
  const params = useParams();
  const { appDispatch } = useContext(AppContext);
  const { taskData } = props;
  const taskItem = taskData[0];

  /**
   * Used for for doc generation status and render UI accordingly
   */
  const docGenerationStatus = useMemo(() => {
    if (taskItem?.proforma_invoice_generation_status as any) {
      return DOCUMENT_GENERATION_STATUS.find(
        (i) => i.value === taskItem?.proforma_invoice_generation_status
      )?.label;
    }
    return null;
  }, [taskItem]);

  return (
    <div className={css.mainWrapper}>
      <Accordion defaultExpanded>
        <Accordion.Header className={css.accordionHeader}>
          <div className={css.header}>
            <div className={css.wrapper}>
              {!taskItem?.is_completed ? (
                <Avatar src={Images.illustrationEdit} alt="" />
              ) : (
                <Avatar src={Images.alertSuccessFaint} alt="" />
              )}
              <Link to={`/order/${props.taskData[0]?.order}`} style={{ textDecoration: 'none' }}>
                <Typography variant="h5" className={css.underlineOnHover}>
                  #{props.taskData[0]?.readable_task_id} - Generate Proforma Invoice
                </Typography>
              </Link>
            </div>
            <div className={css.pocWrapper}>
              {!taskItem?.is_completed && !docGenerationStatus && (
                <Button
                  variant="text"
                  onClick={() => {
                    appDispatch({
                      type: 'setPIData',
                      payload: { task_id: taskItem?.task_id, order_id: taskItem?.order }
                    });
                    navigate(
                      `/order/generate-proforma-invoice/${
                        (params.id as string) ?? (taskItem?.order as string)
                      }`
                    );
                  }}
                  className={css.assignButton}>
                  Generate Form
                </Button>
              )}
              {!taskItem?.is_completed &&
                (docGenerationStatus == 'DOC_GENERATION_PROCESSING' ||
                  docGenerationStatus == 'DOC_GENERATION_REQUESTED') && (
                  <Button variant="text" disabled className={css.assignButton}>
                    Document generation in process
                  </Button>
                )}
              {!taskItem?.is_completed && docGenerationStatus == 'DOC_GENERATION_FAILED' && (
                <Button variant="text" disabled className={css.assignButton}>
                  Document Generation Failed
                </Button>
              )}
            </div>
          </div>
        </Accordion.Header>
      </Accordion>
      <Footer
        createdDate={props.taskData[0].created_at as Date}
        updatedDate={props.taskData[0].updated_at as Date}
      />
    </div>
  );
};

export default GeneratePICard;
